import React, { Component, Fragment, useRef, useEffect, useState } from 'react';

import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-31.0.0-p10xpgutffq2';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import EmojiButton from 'emoji-button';
import {connect} from 'react-redux';








function TextEditor(props){
  let requested_short_codes=useRef(false);
  const[refresh, setRefresh]=useState(0);
  let ed=useRef();
  let first_time=useRef(true);
  let first_value=useRef(undefined);
  useEffect(() => {
  if (ed.current) {
    console.log('CKEditor instance:', ed.current);
    // Add additional debugging information if needed.
  }
}, [ed.current]);
  useEffect(()=>{
    if(props.block_short_codes!=true && props.short_codes==undefined){props.indexShortCodes();}
  },[]);
  console.log('GOOOO', props.short_codes, props.value);
  
  
  //extraPlugins: [MyCustomUploadAdapterPlugin],

//  (editor) => {
//    // Add custom emoji button to CKEditor toolbar
//    editor.ui.componentFactory.add('emoji', (locale) => {
//      const buttonView = new editor.ui.button.ButtonView(locale);
//
//      buttonView.set({
//        label: 'Insert Emoji',
//        icon: '🙂',
//        tooltip: true,
//      });
//
//      // Create Emoji Button Picker
//      const emojiPicker = new EmojiButton({
//        theme: 'light', // Optional: Choose 'light' or 'dark' theme
//      });
//
//      // Toggle emoji picker when the button is clicked
//      buttonView.on('execute', () => {
//        emojiPicker.togglePicker(buttonView.element);
//      });
//
//      // Insert emoji into the editor when an emoji is selected
//      emojiPicker.on('emoji', (selection) => {
//        editor.model.change((writer) => {
//          editor.model.insertContent(
//            writer.createText(selection.emoji),
//            editor.model.document.selection
//          );
//        });
//      });
//
//      return buttonView;
//    });

  let short_codes=[];
    if(props.short_codes!=undefined && props.short_codes!='loading'){for(let key in props.short_codes){short_codes.push('[['+props.short_codes[key].unique_code+']]');}}
    let editorConfiguration={
      ignoreEmptyParagraph:false,
      extraPlugins: [MyCustomUploadAdapterPlugin],
      baseFloatZIndex:100001,
      typing: {
            transformations: {
                remove: [
                    'quotes'
                ]}},
      fontSize: {
            options: [
                5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26
            ]
        },
      toolbar:(props.no_html==true)?[]:{
        removeItems:['uploadImage']
      },
      mediaEmbed:{
        previewsInData:true
      },
      heading: {
            options: [
                { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' }
            ]
        },
      mention: {
            feeds: [
                {
                    marker: '[',
                    feed:short_codes,
                    minimumCharacters: 1
                },
                {
                    marker: '$',
                    feed:["${first_name}", "${last_name}", "${city}", "${company_name}", "${custom_text_1}", "${custom_text_2}", "${custom_text_3}"]
                }
            ]
        }
    }

    function checkForShortCodes(e){
      let div = document.getElementById("strip");
      div.innerHTML = e;
      let ms=div.getElementsByClassName('mention');
      for(let mm of ms){mm.removeAttribute('class'); mm.removeAttribute('data-mention');}
      e=div.innerHTML;
      let value = div.textContent || div.innerText || "";
      //if(value.includes('[[') && requested_short_codes.current==false){props.indexShortCodes(); requested_short_codes.current=true;}
      let array=value.match(/\[\[(.*?)\]\]/g);
      if (array != null) { for (let x of array) { let t = x.replace(/[\[\]]/g, "").replace(/[^a-zA-Z0-9]/g, "_"); console.log(t, 'TTT'); if (props.short_codes != undefined && props.short_codes[t.toUpperCase()] != undefined) { e = (props.no_html == true) ? window.removeHTMLTags(e.replace(x, props.short_codes[t.toUpperCase()].text), false, true): e.replace(x, props.short_codes[t.toUpperCase()].text);}}}
      return e;
    }


    if(props.short_codes==undefined){return null;}
        let value=props.value;
        //NEXT FEW LINES ARE TO SHOW SPACES WHEN EDITING TEXT;
        if(value==='' || value==null || value==undefined){first_time.current=false;}
        
        //if(first_time.current==true && value!=='' && first_value.current==undefined){first_value.current=value; value=''; console.log('FIRST'); window.setTimeout(function(){setRefresh(refresh+1);}, 100); return null;}
       // else if(first_time.current==true && value!==''){console.log('SECOND'); first_value.current=value;  first_time.current=false; value=''; window.setTimeout(function(){setRefresh(refresh+1);}, 100);}
       // else if(first_value.current!=undefined){value=first_value.current; first_value.current=undefined;}

        try {
          //value=decodeURIComponent(escape(props.value))
        } catch (error) {
        }

        return (
          <div style={{width:'100%', position:'relative'}}>
                <CKEditor
                    editor={ClassicEditor}
                    config={editorConfiguration}
                    data={value}
                    onInit={ editor => {
                      ed.current=editor;
                    }}
                    onChange={(event, editor)=>{
                        let data = editor.getData();
                        let old_data=data;
                        data=data.replace('<br>', '');
                        data=checkForShortCodes(data);
                        //data=unescape(encodeURIComponent(data))
                        console.log(data, 'DATA', props.index, value);
                        props.onChange(data);
                    }}
                    onBlur={ ( event, editor ) => {
                    } }
                    onFocus={ ( event, editor ) => {
                    } }
                />
              {(props.error==undefined)?null:<Typography style={{color:(props.error!=undefined)?'red':null}} color={(props.error==true)?'error':undefined}>{props.error}</Typography>}
              <div style={{display:'none'}}><TextField required={props.required} name='none' multiline rows={4} value={props.value} onChange={props.onChange} label='None' InputProps={{display:'none'}}/></div>
          </div>
        );
}


function MyCustomUploadAdapterPlugin(editor) {
  editor.plugins.get( 'FileRepository' ).createUploadAdapter = (loader) => {
    return new MyUploadAdapter(loader)
  }
}

class MyUploadAdapter {
    constructor(props) {
        // CKEditor 5's FileLoader instance.
      this.loader = props;
      // URL where to send files.
      this.url = `/api/upload_image`;
    }

    // Starts the upload process.
    upload() {
        return new Promise((resolve, reject) => {
            this._initRequest();
            this._initListeners(resolve, reject);
            this._sendRequest();
        } );
    }

    // Aborts the upload process.
    abort() {
        if ( this.xhr ) {
            this.xhr.abort();
        }
    }

    // Example implementation using XMLHttpRequest.
    _initRequest() {
        const xhr = this.xhr = new XMLHttpRequest();

        xhr.open('POST', this.url, true);
        xhr.responseType = 'json';
        xhr.setRequestHeader('Access-Control-Allow-Origin', '*')
    }

    // Initializes XMLHttpRequest listeners.
    _initListeners( resolve, reject ) {
        const xhr = this.xhr;
        const loader = this.loader;
        const genericErrorText = 'Couldn\'t upload file:' + ` ${ loader.file.name }.`;

        xhr.addEventListener( 'error', () => reject( genericErrorText ) );
        xhr.addEventListener( 'abort', () => reject() );
        xhr.addEventListener( 'load', () => {
            const response = xhr.response;
            if ( !response || response.error ) {
                return reject( response && response.error ? response.error.message : genericErrorText );
            }

            // If the upload is successful, resolve the upload promise with an object containing
            // at least the "default" URL, pointing to the image on the server.
            resolve({
                default: response.s3Url
            });
        } );

        if ( xhr.upload ) {
            xhr.upload.addEventListener( 'progress', evt => {
                if ( evt.lengthComputable ) {
                    loader.uploadTotal = evt.total;
                    loader.uploaded = evt.loaded;
                }
            } );
        }
    }

    // Prepares the data and sends the request.
    _sendRequest() {
        const data = new FormData();

        this.loader.file.then(result => {
          data.append('file', result);
          this.xhr.send(data);
          }
        )
    }

}



//class CustomEmojiPlugin {
//  constructor(editor) {
//    this.editor = editor;
//  }
//
//  init() {
//    const editor = this.editor;
//
//    // Initialize EmojiButton picker
//    const picker = new EmojiButton();
//
//    // Add an emoji button to the toolbar
//    editor.ui.componentFactory.add('emoji', (locale) => {
//      // Create a button element
//      const button = document.createElement('button');
//      button.textContent = '😊'; // Emoji icon for the button
//      button.classList.add('ck-emoji-button'); // Optional CSS styling
//
//      // Open picker on button click
//      button.addEventListener('click', () => {
//        picker.togglePicker(button); // Open the emoji picker
//      });
//
//      // Handle emoji selection
//      picker.on('emoji', (selection) => {
//        editor.model.change((writer) => {
//          // Insert the selected emoji at the current cursor position
//          editor.model.insertContent(writer.createText(selection.emoji));
//        });
//      });
//
//      return button;
//    });
//  }
//}









export default connect(ss,dd)(TextEditor);

function ss(state){
  return{
    short_codes:state.templates.short_codes
  }
}

function dd(dispatch){
  return{
    indexShortCodes:()=>{dispatch({type:'REQUEST_INDEX_SHORT_CODES'});}
  }
}
